import API from "./api";
import { LOGIN } from "./endpoint";

export const loginUser = (data) => {
  return API.post(LOGIN, data);
};
